//
//
//
//
//
//

export default {
  props: {
    item: ''
  },
  data() {
    return {
      count_down: 5,
      interval: null,
      isShow: false
    }
  },
  created() {
    let that = this
    if (that._func.empty(that.item)) {
      return
    }
    if(!that._func.empty(that.item.intervals)){
        if(!that._func.changeStorage(that.item.img)){
            return 
        }
    }
    that.isShow = true
    that.interval = setInterval(function() {
      if ((that.count_down--) <= 1) {
        that.onCloseGuide()
      }
    }, 1000);
  },
  methods: {
    onCloseGuide() {
      window.clearInterval(this.interval)
      this.isShow = false
      if(!this._func.empty(this.item.intervals)){
          this._func.changeStorage(this.item.img,'set')
      }
    }
  }
}
